import React from 'react';

import { SelectSubscriptionBlock } from '../../../../../payment';
import { useScanIqSubscriptions } from '../../../../hooks/useScanIqSubscriptions';
import { SubmitButton } from '../SubmitButton/SubmitButton';
import { getPriceView } from '../../../../../shared/utils/stringUtils';

const SelectSubscription = () => {
  const {
    applyPromoCode,
    subscriptions,
    discountPercent,
    selectedSubscription,
    setSelectedSubscriptionId,
    handleSubmit,
  } = useScanIqSubscriptions();

  const nextButtonText = `Pay ${
    selectedSubscription
      ? getPriceView(selectedSubscription.monthlyRenewalPriceFinal)
      : ''
  }`;

  return (
    <>
      <SelectSubscriptionBlock
        title="Services"
        onApplyPromoCode={applyPromoCode}
        subscriptions={subscriptions}
        discountPercent={discountPercent}
        selectedSubscriptionId={selectedSubscription?.id || null}
        setSelectedSubscriptionId={setSelectedSubscriptionId}
      />
      <SubmitButton
        text={nextButtonText}
        onSubmit={handleSubmit}
        disabled={!selectedSubscription}
      />
    </>
  );
};

export { SelectSubscription };
